<div class="popup-thank-you-page position-relative">
  @if(!data?.hideIcon === true) {
  <div class="modal-header position-absolute" (click)="closeModal()">
    <img src="assets/images/icons/cross-btn.svg" alt="close-btn" />
  </div>
  }

  <div class="upper-section">
    <div class="icon pt-5 pb-2">
      <img src="assets/images/icons/lead-thank-notebook.svg" alt="thank you" />
    </div>
    <div
      class="text text-center w-100 gap-2 d-flex flex-column align-items-center position-relative"
    >
      <img
        class="character position-absolute"
        src="assets/images/icons/thank-character.svg"
        alt="character"
      />
      <p class="fs-24 fw-bold mb-0 greeting-text">
        Thank you {{ data?.name }} !
      </p>
      <p class="fs-12 m-0 sub-greeting-text">
        Our top three agents will be reaching out to you shortly with the best
        quotes tailored to your needs on {{ data?.phone }}.
      </p>
    </div>
  </div>

  <div class="ticket-container position-absolute">
    <div class="ticket-layout d-flex">
      <img
        src="assets/images/icons/lead-thank-icon.svg"
        alt="thank you"
        class="sub-icon"
      />

      <div class="w-100">
        <div class="head">
          <p class="m-0 fw-medium">REQUEST RECEIVED</p>
          <hr class="solid my-2" style="opacity: 0.15; color: #0d9697" />
        </div>

        <div class="about d-flex flex-column gap-1 position-relative">
          <span class="destination fs-11">
            {{ data?.cityName || data?.fromOthers }} to
            {{ data?.destinationName || data?.packageDestination }} on
            <span *ngIf="data?.departureType === 'flexible'">
              {{ data?.departureWeek }}
            </span>
            <span *ngIf="data?.departureType !== 'flexible'">
              {{ data?.departureDate }}
            </span>
          </span>

          <!-- <span class="day fs-12">{{ data?.tripDuration }} Days Trip</span> -->
          <!-- <div class="persons fs-12">
            <span *ngIf="data?.adults"> {{ data?.adults }} Adults </span>
            <span *ngIf="data?.child">
              | {{ data?.child }} Child{{ data?.child > 1 ? "ren" : "" }}
            </span>
            <span *ngIf="data?.infant"> | {{ data?.infant }} Infant </span>
          </div> -->
          <span class="fs-11">{{ bookingMessage(data.bookingTimeFrame) }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="lower-section">
    <div class="w-100 py-3 button-section">
      <div
        class="d-flex flex-column justify-content-between gap-3 my-4 form-extra-padding"
      >
        <button
          mat-button
          class="btn btn-danger text-white fs-14 w-100 submit fw-normal"
          (click)="goToDashboard()"
        >
          Go to your Dashboard
          <img
            class="btn-arrow-right"
            src="assets/images/icons/btn-arrow-white.svg"
            alt="white-arrow"
          />
        </button>
        <button
          class="btn btn-danger text-white fs-14 w-100 back-btn"
          mat-button
          (click)="closeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
